import { IFilter } from '@vacationtracker/shared/types/filter'
import isEmpty from 'lodash/isEmpty'
import sortBy from 'lodash/sortBy'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const filterData = (filter: IFilter, data: any[]) => {
  const { labelIds, locationIds, teamIds } = filter

  // Convert arrays to Sets for O(1) lookup performance
  const locationIdSet = new Set(locationIds)
  const teamIdSet = new Set(teamIds)
  const labelIdSet = new Set(labelIds)

  const dataFiltered = data.filter((leave) => {
    // Check location filter
    if (!isEmpty(locationIds) && !locationIdSet.has(leave?.user?.location?.id)) {
      return false
    }

    // Check team filter
    if (!isEmpty(teamIds) && !teamIdSet.has(leave?.user?.team?.id)) {
      return false
    }

    // Check label filter
    if (!isEmpty(labelIds)) {
      const userLabels = leave?.user?.labels || []
      const hasMatchingLabel = userLabels.some(label => labelIdSet.has(label.id))
      if (!hasMatchingLabel) {
        return false
      }
    }

    return true
  })

  return sortBy(dataFiltered, ['startDate'])
}